(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompositeController', CompositeController);

    CompositeController.$inject = ['$scope', '$state', 'Composite', 'CompositeSearch', 'CoreService', 'DTOptionsBuilder',
        'DTColumnBuilder', '$q', 'GUIUtils'];

    function CompositeController ($scope, $state, Composite, CompositeSearch, CoreService, DTOptionsBuilder,
                                  DTColumnBuilder, $q, GUIUtils) {
        var vm = this;

        vm.composites = [];
        vm.clinic = CoreService.getCurrentClinic();

        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                CompositeSearch.query({
                    query: {
                        bool: {
                            must: [
                                {term: {"clinic.id": vm.clinic.id}},
                                {term: {"delStatus": false}}
                            ]
                        }
                    }
                }, function (result) {
                    vm.composites = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.bundles, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn('compendium.code').withTitle('Compendium Code'),
            DTColumnBuilder.newColumn('compendium.description').withTitle('Description'),
            DTColumnBuilder.newColumn('billingFrequency.name').withTitle('Frequency'),
            DTColumnBuilder.newColumn('billingFrequency.days').withTitle('Days'),
            DTColumnBuilder.newColumn(null).withTitle('Modality').renderWith(function (data, type, full) {
                return data.dialysisModality ? data.dialysisModality.replace("_", " ") : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();
